import LeftLogin from './LeftLogin'

export default LeftLogin
